// ============================================================================
// UKRAINIAN BIBLE PASSAGES - Ivan Ogienko Translation
// ============================================================================
// Українські біблійні уривки з посиланнями на Стронга

export const biblePassagesUk = {
  "Butyja_1": {
    book: "Буття",
    chapter: 1,
    title: "Творення світу",
    verses: [
      { number: 1, text: "На початку Бог створив небо та землю.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Земля ж була пуста та порожня, і темрява була над безоднею, і Дух Божий ширяв над водою.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "І сказав Бог: Нехай буде світло! І стало світло.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "І побачив Бог світло, що воно добре, і відділив Бог світло від темряви.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "І назвав Бог світло днем, а темряву назвав ніччю. І був вечір, і був ранок - день перший.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "І сказав Бог: Нехай буде твердь посеред води, і нехай відділяє вона воду від води.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "І створив Бог твердь, і відділив воду, що під твердю, від води, що над твердю. І сталося так.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "І назвав Бог твердь небом. І був вечір, і був ранок - день другий.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "І створив Бог людину за образом Своїм, за образом Божим створив її, чоловіка та жінку створив їх.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "І побачив Бог усе, що створив, і ось воно дуже добре. І був вечір, і був ранок - день шостий.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Psalm_23": {
    book: "Псалми",
    chapter: 23,
    title: "Господь мій Пастир",
    verses: [
      { number: 1, text: "Господь мій Пастир, нічого мені не бракне.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Він кладе мене на пасовищах зелених, провадить мене до тихих вод.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Він душу мою підкріплює, провадить мене стежками правди ради Ім'я Свого.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Коли б я йшов навіть долиною смертної тіні, я не боявся б лиха, бо Ти зі мною; Твій жезл і Твоя палиця - вони мене втішають.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Ти готуєш переді мною трапезу проти моїх ворогів, намастив Ти оливою мою голову, мій келих переповнений.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Так, добро і милість супроводжуватимуть мене всі дні життя мого, і я перебуватиму в домі Господньому довгі часи.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Ivana_3": {
    book: "Євангеліє від Івана",
    chapter: 3,
    title: "Ісус і Никодим",
    verses: [
      { number: 16, text: "Бо так Бог полюбив світ, що дав Сина Свого Єдинородного, щоб кожний, хто вірує в Нього, не згинув, але мав життя вічне.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Бо Бог не послав Сина Свого на світ, щоб судити світ, але щоб через Нього спасся світ.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Хто вірує в Нього, той не судиться, а хто не вірує, той уже осуджений, бо не вірує в Ім'я Єдинородного Сина Божого.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Fylypjan_4": {
    book: "До Филип'ян",
    chapter: 4,
    title: "Мир Божий",
    verses: [
      { number: 4, text: "Радійте завжди в Господі; ще раз кажу: радійте!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Ні про що не журіться, але в усьому в молитві та благанні з подякою відкривайте свої бажання перед Богом.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "І мир Божий, що перевищує всякий розум, охоронятиме серця ваші та думки ваші в Христі Ісусі.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Все можу в Христі, що мене підкріплює.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesUk;
